// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Edrq","col":"styles_col__2lI-R"};